import { Building2, Flame, Sun, ArrowRight, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const iconComponents = {
  Building2,
  Flame,
  Sun,
};

export const CategoryCard = ({ category, onSelect }) => {
  const IconComponent = iconComponents[category.icon];
  const isPopular = category.id === 'PAC';

  return (
    <div
      data-testid={`category-card-${category.id}`}
      className={`group relative bg-white rounded-2xl border-2 ${
        isPopular ? 'border-[#0f766e] shadow-lg' : `${category.borderColor} shadow-sm`
      } p-6 lg:p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer`}
      onClick={() => onSelect(category)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onSelect(category)}
    >
      {/* Popular badge */}
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <Badge className="bg-[#0f766e] text-white border-0 px-3 py-0.5 text-xs font-semibold rounded-full shadow-md flex items-center gap-1">
            <Star className="h-3 w-3 fill-current" />
            Le plus demandé
          </Badge>
        </div>
      )}

      {/* Icon */}
      <div
        className={`inline-flex items-center justify-center w-14 h-14 rounded-xl ${category.iconBg} mb-5 transition-all duration-300 group-hover:scale-110 group-hover:shadow-md`}
      >
        {IconComponent && (
          <IconComponent className={`h-7 w-7 ${category.iconColor} transition-transform duration-300 group-hover:rotate-6`} />
        )}
      </div>

      {/* Subtitle badge */}
      <Badge
        variant="outline"
        className="mb-3 text-[0.65rem] font-bold tracking-widest uppercase"
      >
        {category.subtitle}
      </Badge>

      {/* Title */}
      <h3 className="text-xl font-bold text-[#1f2937] mb-2 leading-snug">
        {category.title}
      </h3>

      {/* Description */}
      <p className="text-gray-500 text-sm leading-relaxed mb-5">
        {category.description}
      </p>

      {/* Bottom row */}
      <div className="flex items-center justify-between pt-4 border-t border-gray-100">
        <span className="text-sm font-bold text-[#0f766e]">
          {category.aidRange}
        </span>
        <Button
          data-testid={`qualify-btn-${category.id}`}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(category);
          }}
          className={`rounded-xl text-sm h-9 px-4 transition-all duration-300 ${
            isPopular
              ? 'bg-[#0f766e] hover:bg-[#115e59] text-white shadow-sm'
              : 'bg-transparent border border-teal-200 text-[#0f766e] hover:bg-teal-50 hover:text-[#115e59]'
          }`}
        >
          Qualifier
          <ArrowRight className="ml-1.5 h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
        </Button>
      </div>
    </div>
  );
};
